import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SurveyContent extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        valueCheck: PropTypes.array,
        selectValue: PropTypes.object,
        resultShow: PropTypes.bool,
        handleSelect: PropTypes.func,
    };

    getItemBar = (item, index) => {
        // 投票数
        const countNum = item.num;

        // 投票百分比
        const per = item.nump.toFixed(2);

        // 色条控制
        const colorIndex = parseInt(index % 7);

        return (
            <div className={styles.graphitem}>
                <p className={styles.signbox}>
                    <span className={styles.bar}>
                        <span className={styles[`bar_${colorIndex}`]} style={{ width: `${per}%` }} />
                    </span>
                    <span className={styles.percent}>{per}%</span>
                    <span className={styles.countNum}>{countNum}票</span>
                </p>
            </div>
        );
    };

    render() {
        const { data, valueCheck, selectValue, resultShow, handleSelect } = this.props;

        // 0 已结束 1 进行中
        const status = data.surveyinfo.expire;

        const result = data.result;
        const list = [];

        result.forEach((item, index) => {
            // single 单选 multiple 复选
            const choosetype = item.resultArray.choosetype;

            const qid = item.resultArray.questionid;

            const props = {};

            if (status === '0') {
                props['disabled'] = 'disabled';
            }

            const checkStyle = choosetype === 'single' ? styles.radio : styles.checkbox;
            const style = choosetype === 'single' ? styles.radio_checked : styles.checkbox_checked;

            list.push(
                <li key={index} className={styles.item}>
                    <h3 style={{ color: valueCheck.includes(index) ? '#f54343' : '' }}>
                        {index + 1}. {item.resultArray.question}
                        {valueCheck.includes(index) ? <span>(此问必答)</span> : ''}
                        {choosetype === 'single' ? '' : <span>(多选)</span>}
                    </h3>
                    {item.resultArray.option.map((item, index) => (
                        <div key={index} className={styles.option}>
                            <span className={styles.text}>
                                <label
                                    className={`${checkStyle} ${
                                        selectValue[qid] &&
                                        (selectValue[qid] === item.itemid || selectValue[qid].includes(item.itemid))
                                            ? style
                                            : ''
                                    }`}>
                                    <input
                                        type={choosetype === 'single' ? 'radio' : 'checkbox'}
                                        value={item.itemid}
                                        qid={qid}
                                        name={`sur[${qid}][]`}
                                        {...props}
                                        onChange={handleSelect}
                                    />
                                    <p className={styles.title} style={{ width: resultShow ? '280px' : '' }}>
                                        {item.title}
                                    </p>
                                </label>
                            </span>
                            {resultShow ? this.getItemBar(item, index) : ''}
                        </div>
                    ))}
                </li>,
            );
        });

        return (
            <form className={styles.survey_form}>
                <ul className={styles.survey_list}>{list}</ul>
            </form>
        );
    }
}

export default SurveyContent;
